module.exports = __webpack_public_path__ + "static/media/icon-ig.8b5ce964.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-ig.svg
// module id = 403
// module chunks = 2